/**
 * Manage payments data
 */
import Ajax from '@/lib/ajax_wrapper'

function getSubscriptionsPath(companyId, siteId) {
  return `/admin/companies/${companyId}/sites/${siteId}/payments/subscriptions`
}

function postSubscriptionsPath(siteId) {
  return `/sites/${siteId}/payments/subscriptions`
}

/**
 * Create a subscription
 *
 * @returns {promise}
 */
export function createSiteSubscriptionData(siteId, subscription) {
  return Ajax.request({
    url: `${postSubscriptionsPath(siteId)}`,
    method: 'POST',
    data: {subscription}
  })
}

/**
 * Get a subscription
 *
 * @returns {promise}
 */
export function readSiteSubscriptionData(companyId, siteId) {
  return Ajax.request({
    url: `${getSubscriptionsPath(companyId, siteId)}`,
    method: 'GET'
  })
}

/**
 * Update a subscription
 *
 * @returns {promise}
 */
export function updateSiteSubscriptionData(siteId, data) {
  return Ajax.request({
    url: `${postSubscriptionsPath(siteId)}/change_plan`,
    method: 'POST',
    data: data
  })
}

/**
 * Cancel a subscription
 *
 * @returns {promise}
 */
export function cancelSiteSubscriptionData(siteId) {
  return Ajax.request({
    url: `${postSubscriptionsPath(siteId)}/cancel`,
    method: 'POST'
  })
}

/**
 * Reactive a subscription - whilst it's in cancel mode
 *
 * @returns {promise}
 */
export function reactivateSiteSubscriptionData(siteId) {
  return Ajax.request({
    url: `${postSubscriptionsPath(siteId)}/reactivate`,
    method: 'POST'
  })
}

/**
 * End a trial in a subscription immediately
 *
 * @returns {promise}
 */
export function endSiteSubscriptionTrial(siteId) {
  return Ajax.request({
    url: `/sites/${siteId}/payments/end_trial_subscription`,
    method: 'POST'
  })
}
